import React from 'react';
import Icon from "../../Icon";
//import TagOption from "../../TagOptions";
//import TagList from "../../TagList";
import {PageLoader} from "../../Loader";
import MediaEditor from "./MediaEditor/MediaEditor";
import convertToNext from "../../../../libs/lexical/convertissors/simple";
//import Modal from "../../Modal";
//import {Button} from "../../Button";
//import {config} from "../../../../config";



/*
class MediaDatas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleMoreTag: false,
            mediaType: 0,
            content: "",
            text : "",
            mentions : [],
            mediaTag: [],
            contentReview : 0
        };

        this.editorRef = React.createRef();

        this.handleTags = this.handleTags.bind(this);
        this.handleMediaHotnessTag = this.handleMediaHotnessTag.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.currentMediaIndex !== this.props.currentMediaIndex){
            //this.editorRef.current.updateContent(this.props.currentMedia.contentRaw);
        }
    }

    handleMediaHotnessTag(selectedTag){
        this.props.handleTags("mediaHotness", selectedTag);
    }

    handleTags(SelectTags) {
        let currentTags = [...this.props.currentMedia.tags, ...SelectTags];
        currentTags = Array.from(new Set(currentTags.map(a => a.title)))
            .map(id => {
                return currentTags.find(a => a.title === id)
            });
        this.props.handleTags("tags", currentTags);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.state !== nextState){
            return true;
        }
        if(this.props.currentMedia !== nextProps.currentMedia){
            return true;
        }
        if(this.props.currentMediaIndex !== nextProps.currentMediaIndex){
            return true;
        }
        return this.props.mediaInitialized !== nextProps.mediaInitialized;
    }



    render() {
        return !this.props.currentMedia ? (
                <PageLoader/>
            ) : (
            <div className={`media-datas-wrapper ${this.props.toggleMediaInformations ? 'active' : this.props.toggleMediaInformations === false ? 'hidden' : this.props.toggleMediaInformations === 'undefined' && ''}`}>
                <div className={"informations"}>
                    <div className={"category-title"}><Icon type={"pencil"}/> Informations</div>
                    {this.props.currentMedia.kind === "video" ? <div className={"category-title"}>ASTUCE : Une fois votre vidéo encodée, vous pouvez modifier sa vignette en allant l'éditer.</div> : null }
                    <input type={"text"} className={this.props.currentMedia.title.trim().length === 0 ? 'error' : ''}
                           placeholder={"(Titre obligatoire)"} name={"title"}
                           value={this.props.currentMedia && this.props.currentMedia.title}
                           onBlur={()=>this.props.handleCurrentMedia("title", this.props.currentMedia.title.trim())}
                           onChange={(event) => this.props.handleCurrentMedia("title", event.target.value)} required/>
                    {this.props.currentMedia.title.length === 0 &&
                    <div className={"error-text"}>Choisissez un titre qui décrit votre média.</div>}
                    <DraftTextareaEditor defaultValue={this.props.currentMedia.contentRaw}
                                         placeholder={"Description"}
                                         ref={this.editorRef}
                                         onChange={(contentRaw) => this.setState({contentRaw}, ()=>this.props.handleCurrentMedia("contentRaw", this.state.contentRaw))}/>

                </div>
            </div>
        )
    }
}

 */

const MediaDatas = ({
        media,
        toggleMediaInformations,
        currentMediaIndex,
        handleCurrentMedia = () =>{}
    }) =>{

    function onChangeText(editState){
        let {text} = convertToNext(editState);
        handleCurrentMedia("legend", text);
    }


    return !media ? (
        <PageLoader/>
    ) : (
        <div className={`media-datas-wrapper ${toggleMediaInformations ? 'active' : toggleMediaInformations === false ? 'hidden' : toggleMediaInformations === 'undefined' && ''}`}>
            <div className={"informations"}>
                <div className={"category-title"}><Icon type={"pencil"}/> Légende</div>
                {media?.kind === "video" ? <div className={"category-title"}>ASTUCE : Une fois votre vidéo encodée, vous pouvez modifier sa vignette en allant l'éditer.</div> : null }

                {media?.legend?.length === 0 &&
                    <div className={"error-text"}>Choisissez une légende qui décrit votre publication.</div>}
                {/*<DraftTextareaEditor defaultValue={this.props.currentMedia.contentRaw}
                                     placeholder={"Description"}
                                     ref={this.editorRef}
                                     onChange={(contentRaw) => this.setState({contentRaw}, ()=>this.props.handleCurrentMedia("contentRaw", this.state.contentRaw))}/>*/}
                <MediaEditor
                    key={currentMediaIndex}
                    mentions={[]}
                    text={media?.legend || ""}
                    onChange={(editorState) => onChangeText(editorState)}
                />
            </div>
        </div>
    )
}

export default MediaDatas;